@if (model()) {
  <div class="d-flex gap-4 flex-wrap">
    <app-mdb-button (onClick)="openNewModal()"
                  [text]="'API_INTERFACES.ADD_CUSTOMER'"></app-mdb-button>

  @if (!apiInterfaceCustomerService.loading().loading && apiInterfaceCustomerService.models().length === 0) {
    <app-mdb-button (onClick)="syncCustomers()"
                    [loading]="syncLoading"
                    [outlined]="true"
                    [text]="'API_INTERFACES.SYNC_CUSTOMERS'"></app-mdb-button>
  }
  </div>

  <app-api-interface-customer-table [apiInterface]="model()!"></app-api-interface-customer-table>
}
